// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_PegausuarioporsubResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for pegaUsuarioPorSub() /usuarios/pegaUsuarioPorSub
 * Returns a user object from auth-service.
 * User properties include: sub, username, email, enabled, and other Cognito attributes.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Usuarios_PegausuarioporsubResponseDados {
sub?: string
username?: string
email?: string
enabled?: boolean
phone_number?: string
name?: string
attributes?: Record<string, string | boolean | number>
}

export type Usuarios_PegausuarioporsubResponse = ApiResponse<Usuarios_PegausuarioporsubResponseDados>;

registerResponseContract('Usuarios_PegausuarioporsubResponse', {
  sub:          { type: 'string',  required: false },
  username:     { type: 'string',  required: false },
  email:        { type: 'string',  required: false },
  enabled:      { type: 'boolean', required: false },
  phone_number: { type: 'string',  required: false },
  name:         { type: 'string',  required: false },
  attributes:   { type: 'object',  required: false },
})
